import React from 'react';
import config from '../config';
import PageHeader from '../components/PageHeader';
import Container from '../components/Container';
import TheSnapshotPage from '../components/TheSnapshotPage';
import { NextSeo } from 'next-seo';

function SnapshotPage() {
  const description = `See the list of holders for a given Algorand NFT collection.`;

  return (
    <>
      <NextSeo title={`Shitty Snapshot - ${config.siteName}`} description={description} />

      <div className='pb-12 md:pb-48 bg-bg'>
        <PageHeader
          heading={'Shitty Snapshot'}
          description={description}
          docsLink='https://docs.shittykitties.art/website-utilities/shitty-snapshot'
        />
        <Container>
          <TheSnapshotPage />
        </Container>
      </div>
    </>
  );
}

export default SnapshotPage;
